import template from './component.tpl.html';
import AlMergeTagSelectorController from './controller';

angular.module('festzelt-os.modules.merge-tags')
    .component('alMergeTagsSelector', {
        bindings: {
            guestlistId: '<',
            scopedGuestlists: '<',
            hideNonGuestlist: '<',
            showPreview: '<',
            onPlaceholderSelect: '&',
            entityPrefix: '<'
        },
        templateUrl: template,
        controller: AlMergeTagSelectorController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./src/app/modules/merge-tags/components/al-merge-tags-selector/component.js